import * as e from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/ArrowLineLeft.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(n, { ref: t, ...r, weights: a }));
o.displayName = "ArrowLineLeftIcon";
const m = o;
export {
  m as ArrowLineLeft,
  o as ArrowLineLeftIcon
};
